import { createFileRoute } from '@tanstack/react-router';

// Define the route for the quiz page
export const Route = createFileRoute('/note-quiz')({});
